import script from "./TokenInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenInput.vue?vue&type=script&setup=true&lang=ts"

import "./TokenInput.vue?vue&type=style&index=0&id=4041187f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4041187f"]])

export default __exports__